import { axiosRequest } from './../../service/axios';

export const getData = () => {
  const url = 'dashboard/client';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export default 'getData';
